function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M35.664 75.962a6.901 6.901 0 11-13.802 0 6.901 6.901 0 0113.802 0zM72.662 75.962a6.901 6.901 0 11-13.803 0 6.901 6.901 0 0113.803 0z",
  stroke: "#005646",
  strokeWidth: 5.754
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.792 46.998L22.25 56.716c-.677 1.055-1.359 3.936 1.807 3.936h48.327M32.792 46.998h39.107L85 14.49H17.556M32.792 47l-15.236-32.51M3 3.33h9.122l4.56 9.705.874 1.455",
  stroke: "#005646",
  strokeWidth: 5.754,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 86,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgBasket;